export type PuzzleRewards = {
  type: 'bPoints';
  amount: number;
};

/**
 * The rewards for the very first puzzle
 */
export const puzzleCoinsFirstReward: PuzzleRewards = {
  type: 'bPoints',
  amount: 60,
};

/**
 * Map of bPoints rewards per star rating for completing a puzzle.
 * Reward for 2 stars should be puzzleCoinsRewards[2]
 */
export const puzzleCoinsRewards: Record<number, PuzzleRewards> = {
  1: {
    type: 'bPoints',
    amount: 100,
  },
  2: {
    type: 'bPoints',
    amount: 225,
  },
  3: {
    type: 'bPoints',
    amount: 375,
  },
};
